import { useEffect, useRef, useState } from "react";

const maxHeight = 70;

const DescriptionSeeMore = ({ description }) => {
  const contentRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);

  useEffect(() => {
    if (contentRef.current && contentRef.current.scrollHeight > maxHeight) {
      setShowToggle(true);
    } else {
      setShowToggle(false);
    }
  }, [description]);

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <div className="col-12 mt-3 something_else_description">
      <div className="custom_description_title">Description</div>
      <div className="custom_description_text">
        <div
          ref={contentRef}
          style={{
            maxHeight: isExpanded ? "none" : `${maxHeight}px`,
            overflow: "hidden",
            transition: "max-height 0.3s ease",
          }}
          dangerouslySetInnerHTML={{ __html: description }}
        />
        {showToggle && (
          <span
            className="toggle-text"
            style={{
              color: "var(--portal-theme-primary)",
              cursor: "pointer",
              display: "block",
              marginTop: "5px",
            }}
            onClick={toggleExpand}
          >
            {isExpanded ? "See Less" : "See More"}
          </span>
        )}
      </div>
    </div>
  );
};

export default DescriptionSeeMore;
